export { FilterBuilder }

class FilterBuilder {

    constructor(layer) {
        this.layer = layer;
        this.prefix = "filter";
    }

    harmonizeFilter(filters) {
        const harmonizedFilter = {};

        const add = (column, values) => {
            if (!(column in harmonizedFilter)) {
                harmonizedFilter[column] = [values];
            } else {
                harmonizedFilter[column].push(values)
            }
        };

        for (let i = 0; i < filters.length; ++i) {
            const filter = filters[i];

            if (Array.isArray(filter.values)) for (let j = 0; j < filter.values.length; ++j) {
                const value = filter.values[j];

                switch (value[0].toLowerCase()) {
                    case "bt":
                        if (value.length == 4) {
                            add(value[1], [value[0], value[2], value[3]]);
                        } else if ((value.length == 3) && filter.column) {
                            add(filter.column, value);
                        }
                        break;
                    case "eq":
                    case "like":
                    case "gt":
                    case "gt":
                        if (value.length == 3) {
                            add(value[1], [value[0], value[2]]);
                        } else if ((value.length == 2) && filter.column) {
                            add(filter.column, value);
                        }
                        break;
                    case "null":
                        if (value.length == 2) {
                            add(value[1], [value[0]]);
                        } else if ((value.length == 1) && filter.column) {
                            add(filter.column, value);
                        }
                        break;
                }
            }
        }

        return harmonizedFilter;
    }

    getFilter(harmonizedFilters) { return {} }
    equals(property, value) { }
    between(property, begin, end) { }
    greaterThan(property, value) { }
    lessThan(property, value) { }
    isNull(property) { }
    isLike(property, value) { }
    and(filter) { }
    or(filter) { }

}